export const FpslEliteDisclaimer = ({
  eliteRate,
  defaultRate,
}: {
  eliteRate: string | null;
  defaultRate: string | null;
}) => {
  return (
    <span className="text-gray-500 text-xs">
      <sup>*</sup>
      <a
        className="text-gray-700 underline"
        href="https://alpaca.markets/elite"
        target="_blank"
        rel="noopener"
      >
        Alpaca Elite
      </a>{" "}
      users earn {eliteRate ?? "-"}% of the interest income, while all users are
      guaranteed {defaultRate ?? "-"}% of the interest income. <br />
      <i>
        You can disable the Stock Lending Program at any time through the Plans
        &amp; Features tab.
      </i>
    </span>
  );
};
